import { render, staticRenderFns } from "./serverEdit.vue?vue&type=template&id=a08cee6e&scoped=true&"
import script from "./serverEdit.vue?vue&type=script&lang=js&"
export * from "./serverEdit.vue?vue&type=script&lang=js&"
import style0 from "./serverEdit.vue?vue&type=style&index=0&id=a08cee6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08cee6e",
  null
  
)

export default component.exports